import { useEffect } from 'react';

import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { debounce } from 'lodash-es';
import { useDispatch } from 'react-redux';

import { SearchTypeahead } from 'src/common/SearchTypeahead';

import { setPassengerSearchTerm } from '../passenger.slice';

interface PassengerSearchFormProps {
  searchAction?: ActionCreatorWithPayload<string, string>;
}

export function PassengerSearchForm({
  searchAction = setPassengerSearchTerm,
}: PassengerSearchFormProps) {
  const dispatch = useDispatch();
  const debounceSearch = debounce(handleSearch, 300);

  function handleSearch(term: string) {
    dispatch(searchAction(term));
  }

  useEffect(() => {
    return () => {
      dispatch(searchAction(''));
    };
  }, [dispatch, searchAction]);

  return (
    <SearchTypeahead
      onChange={debounceSearch}
      placeholder="Search passengers"
    />
  );
}
